import { createAction, props } from '@ngrx/store';
import { Pagination } from '../models/pagination.model';
import { Candidate } from '../models/candidate.model';

export const setCandidates = createAction('[Candidates Component] SetCandidates', props<Pagination<Candidate>>());
export const resetCandidates = createAction('[Candidates Component] ResetCandidates');
